import http from '../axios';

export function index() {
  return http.get('/supply_boat_pricings');
}

export function create(payload){
  return http.post('/supply_boat_pricings', payload);
}

export function update(payload) {
  return http.patch(`/supply_boat_pricings/${payload.id}`, payload);
}

export function get_pricing_details(){
   return http.get('/supply_boat_pricings/get_pricing_details');
 }